import Vue from 'vue';
import VueRouter from 'vue-router';
import store from '@/store';

Vue.use(VueRouter);

import { routes } from './routes';

let mode = process.env.VUE_APP_PLATFORM === 'cordova' ? 'hash' : 'history';

const router = new VueRouter({
  mode,
  routes,
});

router.$status = new Vue({
  data: {
    navigationType: 'forward',
  },
});

router.back = function() {
  this.go(-1);
};

let lastPath;

router.beforeEach((to, from, next) => {
  // Determine navigation direction

  let toDepth = to.path.split('/').length;
  let fromDepth = from.path.split('/').length;

  if (to.path.charAt(to.path.length - 1) !== '/') {
    toDepth += 1;
  }
  if (from.path.charAt(from.path.length - 1) !== '/') {
    fromDepth += 1;
  }
  router.$status.navigationType = toDepth > fromDepth ? 'forward' : 'back';

  if (toDepth === fromDepth) {
    // If the depth is the same determine whether the to path is in the history
    if (lastPath === to.path) {
      router.$status.navigationType = 'back';
    } else {
      router.$status.navigationType = 'forward';
    }

    lastPath = from.path;
  }

  // Re-route login if authenticated
  if (store.state.user.authenticated && to.name === 'Login') {
    next('/');
  } else {
    next();
  }
});

export default router;
